import { Box, Flex, Link, Text } from "@chakra-ui/react";
import Footer from "components/footer/FooterAuth";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";

function AuthIllustration(props: { children: JSX.Element | string }) {
  const { children } = props;
  return (
    <Flex position="relative" h="max-content">
      <Flex
        h={{
          sm: "initial",
          md: "unset",
          lg: "100vh",
          xl: "97vh",
        }}
        w="100%"
        maxW={{ md: "66%", lg: "1313px" }}
        mx="auto"
        pt={{ sm: "50px", md: "0px" }}
        px={{ lg: "30px", xl: "0px" }}
        ps={{ xl: "70px" }}
        justifyContent="start"
        direction="column"
      >
        {children}
        <Box
          display={{ base: "none", md: "block" }}
          h="100%"
          minH="100vh"
          w={{ lg: "50vw", "2xl": "44vw" }}
          position="absolute"
          right="0px"
        >
          <Flex
            w="100%"
            h="100%"
            minH="100vh"
            position="absolute"
            bgGradient="linear(to-br, brand.800, brand.600, brand.500)"
            justify="center"
            align="center"
            direction="column"
            px={{ lg: 10, xl: 14 }}
            borderBottomLeftRadius={{ lg: "120px", xl: "200px" }}
            overflow="hidden"
          >
            <Box
              position="absolute"
              top="-20%"
              right="-30%"
              w="70%"
              h="70%"
              borderRadius="full"
              bg="whiteAlpha.100"
              pointerEvents="none"
            />
            <Box
              position="absolute"
              bottom="-25%"
              left="-20%"
              w="60%"
              h="60%"
              borderRadius="full"
              bg="blackAlpha.200"
              pointerEvents="none"
            />
            <Text
              position="relative"
              fontSize={{ lg: "5xl", xl: "6xl" }}
              fontWeight="normal"
              color="white"
              letterSpacing="tight"
              textAlign="center"
              fontFamily="Volkhov-Bold"
            >
              OnlyWine
            </Text>
            <Text
              position="relative"
              mt={3}
              fontSize={{ lg: "lg", xl: "xl" }}
              color="whiteAlpha.900"
              fontWeight="medium"
              textAlign="center"
            >
              Portal do Parceiro
            </Text>
            <Box
              position="relative"
              mt={10}
              px={6}
              py={4}
              borderRadius="2xl"
              bg="whiteAlpha.200"
              backdropFilter="blur(10px)"
              maxW="sm"
              textAlign="center"
            >
              <Text fontSize="sm" color="whiteAlpha.900" mb={1}>
                Conheça a OnlyWine em
              </Text>
              <Link
                href="https://onlywine.app"
                isExternal
                fontSize="lg"
                fontWeight="bold"
                color="white"
                _hover={{ color: "whiteAlpha.800", textDecoration: "underline" }}
              >
                onlywine.app
              </Link>
            </Box>
          </Flex>
        </Box>
        <Footer />
      </Flex>
      <FixedPlugin />
    </Flex>
  );
}

export default AuthIllustration;
